export default {
  analytics: {
    header: {
      title: 'Métricas',
      back: 'Voltar para as minhas páginas',
      subtitle: {
        edit: 'Editar',
      },
    },
    info: {
      cacheDelay: '*A atualização das métricas da página pode ocorrer em até um dia',
    },
  },
  boxes: {
    total: 'Total',
    conversions: {
      title: 'Conversões',
      conversionRate: 'Taxa de Conversão',
      showEmails: 'Ver e-mails capturados',
      conversionType: 'Identificador da conversão',
      subscriptionIdentifier: 'Inscrição no formulário de e-mail',
      linkIdentifier: 'Link {identifier}',
    },
    duration: {
      title: 'Duração média',
    },
    visitors: {
      title: 'Visitantes',
      unique: 'Únicos',
      local: 'Local',
      country: 'País',
      visits: 'Visitas',
      showMap: 'Ver origem dos visitantes',
    },
  },
  date: {
    simpleFormat: 'dd/MM/yyyy',
    dateAndTime: 'DD/MM/YYYY HH:mm',
    simpleFormatDash: 'DD-MM-YYYY',
  },
  emailsList: {
    title: 'E-mails capturados',
    emailColumn: 'Endereço de E-mail',
    dateColumn: 'Data',
    searchPlaceholder: 'Procurar endereço',
    capturedEmails: 'Nenhum e-mail capturado | 1 e-mail capturado | {count} e-mails capturados',
    export: {
      button: 'Exportar',
      fileName: 'Lista de e-mails capturados',
    },
  },
  pagination: {
    previous: 'Anterior',
    next: 'Próximo',
  },
  chart: {
    period: 'Período',
    date: {
      from: 'De',
      to: 'Até',
      invalidPeriod: 'A data inicial do período deve ser menor do que a data final. Por favor, selecione outro período de datas.',
    },
    filter: 'Filtrar e exibir gráfico',
    granularity: {
      hour: {
        label: 'Hora',
        format: 'DD/MM [às] HH[h]',
      },
      day: {
        label: 'Dia',
        format: 'DD/MM',
      },
    },
    noData: 'Sem dados no período',
  },
  locations: {
    title: 'Origem dos visitantes',
    searchPlaceholder: 'Filtrar localidade',
    visitors_percent: '% dos visitantes',
    visitors: 'Nenhum visitante | 1 visitante | {count} visitantes',
    cities: 'de 1 cidade | de {count} cidades',
    countries: 'em 1 país | em {count} países',
    not_identified: 'Não identificado',
  },
  notifications: {
    noNotifications: 'Não há novas notificações.',
    unableLoad: 'Não foi possível carregar as notificações no momento.',
  },
  loading: {
    title: 'Estamos processando a ação. Aguarde enquanto carregamos os dados.',
    subtitle: 'A requisição pode demorar alguns minutos.',
  },
  error: {
    notFound: {
      title: 'Não foi possível encontrar as métricas desta página',
      buttons: {
        home: 'Ir para página inicial',
      },
    },
    metricsProcess: {
      title: 'Tivemos um erro por aqui',
      subtitle: 'Não conseguimos carregar esta página agora, mas estamos trabalhando para resolver o problema. Tente novamente em alguns minutos. Se o problema continuar, você pode entrar em contato com o nosso Suporte.',
      buttons: {
        home: 'Tentar novamente',
        support: 'Falar com Suporte',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/ptBr.js